@import '~style-sheet-helpers/core';
@import '../../../../app-brand/entities/entity-layer.module.less';

.grid-rows-container {
  .group-by-grid-separator {
    display: flex;
    height: 30px;
    background-image: linear-gradient(
      @hooks-display-grid--group-by-grid-separator--background-gradient-color-1 0%,
      @hooks-display-grid--group-by-grid-separator--background-gradient-color-2 20%
    );
    border-top: @hooks-display-grid--group-by-grid-separator--border-color 1px solid;
    border-bottom: @hooks-display-grid--group-by-grid-separator--border-color 1px solid;
  }
  .grid-rows {
    display: grid;
    background-color: @hooks-display-grid--row--background-color;
    line-height: 30px;
    grid-auto-rows: 30px;
    border-bottom: 1px solid @hooks-display-grid--row--border-color;

    &.group-item {
      border-bottom: none;

      &.pinned {
        padding-left: 10px;
      }
    }

    &.group-header {
      &.not-pinned {
        display: flex;
        height: 31px;
        padding-left: 15px;
      }
      & > * {
        overflow: visible;
      }
    }

    &.render-shadow {
      box-shadow: 1px 0 0 @hooks-display-grid--pinned-column--box-shadow-color;
    }

    &.hovered {
      background: @hooks-display-grid--row--hover--background-color;
      &.expandable {
        border-bottom: 1px solid @hooks-display-grid--row--hover--background-color;
      }
    }
    &.selected {
      background: @hooks-display-grid--row--selected--background-color;

      &:not(.group-item) {
        border-bottom: 1px solid @hooks-display-grid--row--selected--border-color;
        border-top: 1px solid @hooks-display-grid--row--selected--border-color;
      }

      &.negativeMarginTop {
        margin-top: -1px;
      }

      &:hover,
      &.hovered {
        background: @hooks-display-grid--row--selected--background-color;
      }

      &.expandable {
        border-bottom: 1px solid @hooks-display-grid--row--selected--background-color;
        border-top: 0;

        &.borderDashed {
          border-bottom: 1px dashed @hooks-display-grid--row--selected--border-color;
        }

        &.borderBottom {
          border-bottom: 1px solid @hooks-display-grid--row--selected--border-color;
        }

        &.borderTop {
          border-top: 1px solid @hooks-display-grid--row--selected--border-color;
        }
      }
    }
    &.expandable {
      border-bottom: 1px solid @hooks-display-grid--row--background-color;
      display: none;

      &.borderDashed {
        border-bottom: 1px dashed @hooks-display-grid--row--expandable--border-color;
        display: grid;
      }

      &.borderBottom {
        border-bottom: 1px solid @hooks-display-grid--row--expandable--border-color;
        display: grid;
      }

      &.visible {
        display: grid;
      }
    }

    .group-by-header-detail {
      margin-right: 10px;
      B {
        margin-right: 5px;
      }
    }

    & > * {
      color: @hooks-display-grid--row--text-color;
      font-size: 14px;
      overflow: hidden;
      padding: 0 10px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &.greyed * {
      color: @hooks-display-grid--row--grey-text-color;
      font-style: italic;
    }
  }
}

.expander {
  margin-right: 6px;
  padding: 0 1px;
  transform: translateY(-1.5px);

  &:hover {
    text-decoration: none;
  }

  &.expanded {
    transform: rotate(90deg);
  }
  > span {
    font-size: 26px;
  }
}

.groupby-action-popover-body {
  width: 180px;
  border-radius: 5px;

  .groupby-action-popover-item {
    display: flex;
    width: 100%;
    border-bottom: 1px @hooks-display-grid--group-by-action-popover--border-color solid;
    padding: 15px;
    font-size: 14px;
    cursor: pointer;
    line-height: 20px;

    &:hover {
      background-color: @hooks-display-grid--group-by-action-popover--hover--background-color;
    }
  }
}
